import {type StateTree} from 'pinia';
import DialogType from "~/components/Common/Dialog/model/DialogType";

export interface DialogStoreStateOption {
    type: DialogType;
    props?: any;
    confirm?: {
        title?: string;
        event: () => void;
    };
    close?: {
        title?: string;
        event: () => void;
    };
    // [X]는 기본적으로 close 와 같다. close 가 «머무르기» 가 아닌 팝업만 [X]의 동작을 따로 준다.
    exit?: {
        event: () => void;
    };
}

export interface DialogStoreState extends StateTree {
    show: boolean;
    options: DialogStoreStateOption;
    multiOption: DialogStoreStateOption[];
}

export const state = (): DialogStoreState => ({
    show: false,
    options: {
        type: DialogType.None
    },
    multiOption: []
});
